module.exports = __webpack_public_path__ + "static/img/2577_phase_function_Paper_Points.48756ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2577_phase_function_Paper_Points.png
// module id = vTlQ
// module chunks = 0